module.exports = __webpack_public_path__ + "static/media/cvetomer-schema.e4836578.png";